/**
 * billingCenterModule 超管-计费中心
 * Author Qian.qianchen 2019-07-05
 */
'use strict';
angular.module("billingCenterModule", [])
    .controller("billingCenterCtrl", ["$scope", "trsspliceString", "$q", "$filter", "modalDialog", "trsHttpService", '$timeout',
        function($scope, trsspliceString, $q, $filter, modalDialog, trsHttpService, $timeout) {
            initStatus()
            initData()
                /**
                 * [initStatus description] 状态初始化
                 * @return {[type]} [description]
                 */
            function initStatus() {
                $scope.status = {
                    statusList: [{ name: '全部状态', value: 0 }, { name: '已启用', value: 1 }, { name: '已停用', value: -1 }],
                    statusObj: {
                        "1": "已启用",
                        "-1": "已停用",
                    },
                    remarkObj: {
                        "1": "停用",
                        "-1": "启用",
                    },
                    keywords: '',
                    childTableShowFlag: true,
                }
                $scope.data = {
                    selectedStatus: [],
                    items: [],
                }
            }
            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                $scope.data.selectedStatus = $scope.status.statusList[0];
                getData();
            }
            /** 
             * [getData description] 请求数据
             */
            function getData() {
                let deffer = $q.defer();
                let params = {
                    "serviceid": "mlf_billing",
                    "methodName": "queryBillingModules",
                    "Status": $scope.data.selectedStatus.value,
                };
                if ($scope.status.keywords) {
                    params.ModuleName = $scope.status.keywords;
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "GET").then(function(result) {
                    $scope.data.items = result == '' ? [] : result;
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [requestData description] 数据请求
             * @param  {[type]} ev [description]
             * @return {[type]}    [description]
             */
            $scope.requestData = function(ev) {
                    if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                        getData()
                    }
                }
                /** 
                 * [remarkFn description]操作函数
                 */
            $scope.remarkFn = function(item) {
                var title, tip;
                if (item.STATUS == 1) {
                    title = "确定停用" + item.BILLINGMODULENAME + "吗？";
                    tip = '停用会影响在使用中的功能，请谨慎操作。';
                } else {
                    title = "确定启用" + item.BILLINGMODULENAME + "吗？";
                    //tip = '启用会影响在使用中的功能，请谨慎操作。';
                }
                modalDialog.alertType(title, tip, "warning", true, () => {
                    let params = {
                        "serviceid": "mlf_billing",
                        "methodName": "updateBillingModuleStatus",
                        "BillingModuleIds": item.BILLINGMODULEID,
                        "Status": item.STATUS == 1 ? -1 : 1,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "GET").then(function(result) {
                        getData()
                    });
                });
                $timeout(() => {
                    $($('.modal-dialog .content p')[1]).css('font-size', '14px');
                }, 100)
            }
        }
    ]);